﻿import React from 'react';
import {styled} from "@mui/styles";

const Root = styled('img')(() => ({
  objectFit: 'cover',
  width: '100%',
  height: '282px',
  borderRadius: '0.5em',
}));

type CardCoverFitImageProps = React.ComponentPropsWithoutRef<'img'>

/**
 * Made to support the large image for location card, honestly might be too specific to be in here. i dunno
 * @param className extra classes to add on top of cardCoverFitImage
 * @param alt image alt text, included specifically because lint gets made
 * @param rest any extra props to be passed to the underlying img component
 * @constructor
 */
const CardCoverFitImage = ({alt, ...rest}: CardCoverFitImageProps) => {
  return <Root alt={alt} {...rest} />
}

export { CardCoverFitImage };
